import Message from './components/Message';
import Company from './components/Company';

export default function CompanyPage() {
  return (
    <>
      <section className="pt-32 md:pt-40 pb-4 px-4 md:px-6 bg-[#0d0d1a]">
        <div className="max-w-6xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#1e1e3f] border border-[#3b3b6b]">
            <span className="w-2 h-2 rounded-full bg-[#a855f7]"></span>
            <span className="text-xs font-medium tracking-[0.22em] uppercase text-[#a78bfa]">Company</span>
          </div>
          <h1 className="mt-5 text-3xl md:text-5xl font-extrabold text-white">会社情報</h1>
          <p className="mt-4 text-[#a0a0b0] text-base md:text-lg max-w-3xl leading-relaxed">
            株式会社ルヴィラの会社概要と、代表からのメッセージをご紹介します。
          </p>
        </div>
      </section>

      <Message />
      <Company />
    </>
  );
}